import React from 'react'

function Forgetpass() {
  return (
    <div>Forgetpass</div>
  )
}

export default Forgetpass